import React from 'react';
import { Target, Shield, TrendingUp, Users } from 'lucide-react';

const About = () => {
  const features = [
    {
      icon: Target,
      title: 'Comparaisons objectives',
      description: 'Nous analysons chaque opérateur avec rigueur pour vous présenter uniquement les meilleures options.',
      color: 'text-toxic-green',
    },
    {
      icon: Shield,
      title: 'Opérateurs agréés uniquement',
      description: 'Tous les sites présentés sont licenciés par l\'ANJ et respectent les normes françaises de sécurité.',
      color: 'text-toxic-cyan',
    },
    {
      icon: TrendingUp,
      title: 'Maximisez vos gains',
      description: 'Découvrez les meilleures cotes et bonus pour optimiser vos paris et augmenter vos chances de succès.',
      color: 'text-toxic-pink',
    },
    {
      icon: Users,
      title: 'Conseils d\'experts',
      description: 'Bénéficiez de nos guides pratiques et de nos recommandations basées sur l\'expérience réelle.',
      color: 'text-toxic-yellow',
    },
  ];

  return (
    <section id="about" className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-black to-purple-900/10" itemScope itemType="https://schema.org/Organization">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="bg-gradient-to-r from-toxic-pink to-toxic-cyan bg-clip-text text-transparent" itemProp="name">
              Pourquoi Rouge Bets ?
            </span>
          </h2>
          <p className="text-xl text-white/70 max-w-3xl mx-auto" itemProp="description">
            Nous sommes votre partenaire de confiance pour naviguer dans l'univers des paris sportifs en France. 
            Notre mission : vous aider à faire les meilleurs choix pour une expérience de paris optimale.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {features.map((feature, index) => (
            <div
              key={index}
              className="glass rounded-xl p-6 border border-white/10 hover:border-toxic-green/50 transition-all hover:scale-105"
            >
              <div className={`w-12 h-12 rounded-lg glass-strong flex items-center justify-center mb-4 ${feature.color}`}>
                <feature.icon className="w-6 h-6" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2">{feature.title}</h3>
              <p className="text-white/70 text-sm leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="glass-strong rounded-2xl p-8 md:p-12 border border-toxic-green/30 max-w-4xl mx-auto">
          <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">
            Notre engagement envers vous
          </h3>
          <p className="text-white/80 leading-relaxed mb-4" itemProp="description">
            Rouge Bets est un site indépendant qui compare les opérateurs de paris sportifs agréés en France. 
            Nous testons chaque plateforme, analysons les bonus, comparons les cotes et évaluons l'expérience utilisateur 
            pour vous fournir des informations précises et à jour.
          </p>
          <p className="text-white/80 leading-relaxed" itemProp="description">
            Notre objectif est simple : vous aider à trouver le site qui correspond le mieux à vos besoins, 
            que vous soyez débutant ou parieur expérimenté. Nous mettons en avant les avantages réels de chaque opérateur 
            pour que vous puissiez prendre une décision éclairée.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;

